import { render, staticRenderFns } from "./gc-batch-goods-return.vue?vue&type=template&id=3061c034"
import script from "./gc-batch-goods-return.vue?vue&type=script&lang=js"
export * from "./gc-batch-goods-return.vue?vue&type=script&lang=js"
import style0 from "./gc-batch-goods-return.vue?vue&type=style&index=0&id=3061c034&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports